import FacebookIcon from "./Assets/Icons/icon_facebook.svg";
import InstagramIcon from "./Assets/Icons/icon_instagram.svg";

import AppStoreLogo from "./Assets/Imgs/logo_app-store.png";
import GooglePlayLogo from "./Assets/Imgs/logo_google-play.png";

export const FOOTER_RIGHT_LINKS = (t, language) => [
  {
    name: t("career"),
    link: "https://careers.shopee.com.my/",
  },
  {
    name: t("customerService"),
    link: language === "ms" ? "/ms/hubungi-kami" : "/en/contact-us",
  },
  {
    name: t("frequentlyAskedQuestions"),
    link: "https://help.shopee.com.my/portal/4/category/31-Payments/667-Payment-options?page=1",
  },
];

export const FOOTER_LEFT_SOCIAL_MEDIA_LINKS = [
  {
    icon: FacebookIcon,
    alt: "facebook",
    link: "https://www.facebook.com/ShopeePayMY",
  },
  {
    icon: InstagramIcon,
    alt: "instagram",
    link: "https://www.instagram.com/shopeepay_my/",
  },
];

export const FOOTER_LEFT_DOWNLOAD_LINKS = [
  {
    logo: AppStoreLogo,
    alt: "app-store",
    link: "https://shopeepaymy.onelink.me/U40j/Website",
  },
  {
    logo: GooglePlayLogo,
    alt: "google-play",
    link: "https://shopeepaymy.onelink.me/U40j/Website",
  },
  // {
  //   logo: AppGalleryLogo,
  //   alt: "app-gallery",
  //   link: "https://appgallery.huawei.com/app/C100576469?sharePrepath=ag&channelId=web&detailType=0",
  // },
];
